import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/features/events/Gallery.css";

const photos = [
  { id: 1, src: "/gallery/event1.1.avif", w: 1600, h: 1067, alt: "Silent disco rooftop", caption: "Silent Disco Rooftop – maj" },
  { id: 2, src: "/gallery/event1.2.avif", w: 1600, h: 1067, alt: "Warsztaty świec sojowych", caption: "Warsztaty świec – marzec" },
  { id: 3, src: "/gallery/event1.3.avif", w: 1600, h: 1067, alt: "Dating Night", caption: "Dating Night – Warszawa" },
  { id: 4, src: "/gallery/event1.8.jpg", w: 1600, h: 1067, alt: "Dating Night", caption: "Dating Night – Warszawa" },
  { id: 5, src: "/gallery/event1.5.jpg", w: 1600, h: 1067, alt: "Dating Night", caption: "Dating Night – Warszawa" },
  { id: 6, src: "/gallery/event1.6.jpg", w: 1600, h: 1067, alt: "Dating Night", caption: "Dating Night – Warszawa" },
  { id: 7, src: "/gallery/event1.7.jpg", w: 1600, h: 1067, alt: "Dating Night", caption: "Dating Night – Warszawa" },
  { id: 8, src: "/gallery/event1.4.jpg", w: 1600, h: 1067, alt: "Dating Night", caption: "Dating Night – Warszawa" },
  { id: 9, src: "/gallery/event1.9.jpg", w: 1600, h: 1067, alt: "Dating Night", caption: "Dating Night – Warszawa" }
];

export default function Gallery() {
  const navigate = useNavigate();

  useEffect(() => {
    const io = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && e.target.classList.add("inview")),
      { threshold: 0.12 }
    );
    document.querySelectorAll(".reveal").forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  const openLightbox = (src, alt, caption) => {
    const modal = document.getElementById("lightbox-modal");
    const img = modal.querySelector("img");
    const cap = modal.querySelector(".lb-caption");
    img.src = src;
    img.alt = alt || "";
    cap.textContent = caption || "";
    modal.classList.add("open");
  };

  const closeLightbox = () => {
    document.getElementById("lightbox-modal").classList.remove("open");
  };

  return (
    <div className="gallery-page">
      <section className="section band band--sand">
        <div className="section-head">
          <h2>Zdjęcia z jesiennego pikniku</h2>
          <p className="muted">Zobacz klimat naszych imprez i warsztatów ✨</p>
        </div>

        <div className="gallery-grid reveal">
          {photos.map((p) => (
            <figure key={p.id} className="g-item" onClick={() => openLightbox(p.src, p.alt)}>
              <img
                src={p.src}
                alt={p.alt}
                loading="lazy"
                width={Math.min(500, p.w)}
                height={Math.round((Math.min(500, p.w) * p.h) / p.w)}
              />
            </figure>
          ))}
        </div>

        <div className="split-cta">
          <button className="btn btn-primary" onClick={() => navigate("/events")}>Zobacz nadchodzące eventy</button>
        </div>
      </section>

      {/* Lightbox */}
      <div id="lightbox-modal" className="lb-backdrop" onClick={closeLightbox} role="dialog" aria-modal="true">
        <div className="lb-content" onClick={(e) => e.stopPropagation()}>
          <button className="lb-close" onClick={closeLightbox} aria-label="Zamknij">×</button>
          <img src="" alt="" />
          <div className="lb-caption" />
        </div>
      </div>
    </div>
  );
}
